import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholischoolpicninc() {



    const cardData =
    {
        keyword: 'Morachi Chincholi School Picnic Spot',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi School Picnic Spot',
        headingDescription: 'Looking for the ideal Morachi Chincholi school picnic spot that offers fun, safety, and learning? Anand Krushi Paryatan Kendra, just 55 km from Pune, is a top-rated destination for school outings. Set across 40 acres of lush greenery, this agri-tourism center is designed to give students a full day of hands-on rural experiences and joyful activities. As a leading Morachi Chincholi school picnic spot, the center offers a variety of engaging options including bullock cart and tractor rides, horse riding, boating, swimming, and rain dance. Students are also treated to cultural shows like magic acts and puppetry, along with traditional village games that encourage teamwork and exploration.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',
topPlaces: [
  {
    "title": "Peacock Spotting & Nature Trails",
    "description": "Start the picnic with guided nature walks through farmlands, ponds, and orchards. Students often spot free-roaming peacocks, parakeets, and bulbuls—great for early-morning adventures and nature photography."
  },
  {
    "title": "Bullock Cart & Tractor Rides",
    "description": "Take students on fun, bumpy rides across village tracks in decorated bullock carts and farm tractors. This rural experience is both entertaining and educational, offering insight into village transport heritage."
  },
  {
    "title": "Traditional Village Games",
    "description": "Organise group games like kho-kho, kabaddi, lagori, sack race, and gilli-danda on open playgrounds. These energy-packed activities promote teamwork, physical fitness, and joyful interaction among students."
  },
  {
    "title": "Interactive Farm Learning",
    "description": "Teachers can lead hands-on stations where students plant seeds, water saplings, create compost pits, and learn about seasonal crops and organic farming—all guided by local farmers."
  },
  {
    "title": "Animal Feeding & Dairy Visit",
    "description": "Visit the farm’s dairy section where students can feed calves, milking demonstration sessions, and observe goats and ducks—a wonderful way to learn about farm animals and their care."
  },
  {
    "title": "Craft & Diya-Painting Workshops",
    "description": "Set up creative corners for clay pottery, diya painting, and leaf-print crafts. These activity sessions help students explore their artistic side and take home handmade souvenirs."
  },
  {
    "title": "Nutritious Rural Meals",
    "description": "Serve wholesome Maharashtrian-style meals—breakfast (poha, upma), unlimited thali lunch on banana leaves, and evening snacks. Meals are cooked fresh, healthy, and kid-friendly."
  },
  {
    "title": "Rain Dance & Splash Zone",
    "description": "Cool off after afternoon sessions with fun rain dance and splash pool time. DJ-backed music and safe pool areas make this a favorite for summer trips and enthusiastic kids."
  },
  {
    "title": "Puppet/Magic Show & Cultural Fun",
    "description": "Students enjoy engaging puppet shows, magic acts, or folk storytelling sessions in a shaded outdoor space—combining laughter, culture, and entertainment."
  },
  {
    "title": "Group Photo Spots & Return Gifts",
    "description": "End the day with a group photo under iconic village backdrops—like bullock carts or peacock trails. Students also receive small take-home tokens like clay tokens or seed packets."
  }
],




  "services": [
    {
      "name": "Best School-Friendly Spot in Morachi Chincholi",
      "description": "Secure, spacious and scenic—designed specifically for school excursions, with easy access, buffer zones, and group-friendly organisation."
    },
    {
      "name": "Farm-Based Education Trip",
      "description": "Hands-on farm tours where students learn crop cycles, composting, irrigation practices, and seasonal harvest techniques alongside instructors."
    },
    {
      "name": "Safe Playgrounds for Students",
      "description": "Fenced, age-segregated play areas with slides, swings and soft-flooring to ensure students have fun in a safe environment."
    },
    {
      "name": "Fun Animal Interaction Zones",
      "description": "Pet farms featuring goats, rabbits, ducks, and chickens—supervised interactions that let children learn about animal care in real time."
    },
    {
      "name": "Interactive Farming Demos",
      "description": "Guided sessions where kids participate in sowing, weeding, harvesting, and planting while understanding ecological concepts."
    },
    {
      "name": "Cultural Exposure for Kids",
      "description": "Folk music, traditional dance, storytelling, and local crafts—designed to introduce students to rural Maharashtrian culture."
    },
    {
      "name": "Group Lunch Zones",
      "description": "Designated dining spaces with benches, shade, and sanitation, serving hygienic vegetarian meals made from farm-fresh produce."
    },
    {
      "name": "Clean Toilets and Hygiene Maintained",
      "description": "Regularly cleaned washrooms, hand-washing stations, and water availability to ensure student well-being throughout the visit."
    },
    {
      "name": "Games and Nature Activities for Children",
      "description": "Curated outdoor games—relay races, treasure hunts, bird-spotting walks—blending recreation and environmental learning."
    },
    {
      "name": "Learning via Nature Sessions",
      "description": "Mini science sessions in the open—covering plant and insect anatomy, local ecology, tree identification, and sustainability themes."
    },
    {
      "name": "On-Site Guides and Support Staff",
      "description": "Trained facilitators with ideal student–staff ratios who ensure safety and enhance learning during all activities."
    },
    {
      "name": "Special School Packages Available",
      "description": "Customised school programs with schedule flexibility, learning targets, meals, snacks, and transport/logistics support."
    },
    {
      "name": "Booking and Travel Help",
      "description": "Simple online booking system, transport coordination (bus/van), permission letters, and real-time assistance for group leaders."
    },
    {
      "name": "Relaxing and Fun Environment for Students",
      "description": "A balanced environment of fields, shade, and quiet corners—designed to refresh students while engaging them mentally and physically."
    },
    {
      "name": "Age‑Appropriate Games and Shows",
      "description": "Tailored activities matched to age groups—puppet shows, folk skits for little kids, and adventure games for older students."
    }
  ],
  "tableData": [
    ["Best School-Friendly Spot in Morachi Chincholi", "Farm-Based Education Trip"],
    ["Safe Playgrounds for Students", "Fun Animal Interaction Zones"],
    ["Interactive Farming Demos", "Cultural Exposure for Kids"],
    ["Group Lunch Zones", "Clean Toilets and Hygiene Maintained"],
    ["Games and Nature Activities for Children", "Learning via Nature Sessions"],
    ["On-Site Guides and Support Staff", "Special School Packages Available"],
    ["Booking and Travel Help", "Relaxing and Fun Environment for Students"],
    ["Age‑Appropriate Games and Shows", ""]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Tailored School Picnic Packages",
    "WhyChoosedescription": "Mauli Krushi Paryatan Kendra offers customized school picnic packages with activities like nature walks, bird watching, and traditional games, ensuring an educational and enjoyable experience for students."
  },
  {
    "WhyChooseheading": "Engaging Outdoor Activities",
    "WhyChoosedescription": "Students can participate in various outdoor activities such as bullock cart rides, tractor tours, zip-lining, and archery, promoting teamwork and physical fitness in a natural setting."
  },
  {
    "WhyChooseheading": "Comfortable Accommodation Options",
    "WhyChoosedescription": "The center provides comfortable accommodation options, including cottages and dormitories, equipped with modern amenities to ensure a pleasant stay for school groups."
  },
  {
    "WhyChooseheading": "Cultural and Culinary Experiences",
    "WhyChoosedescription": "Students can experience authentic Maharashtrian cuisine and cultural activities, enhancing their understanding of local traditions and fostering cultural appreciation."
  },
  {
    "WhyChooseheading": "Eco-Friendly and Peaceful Environment",
    "WhyChoosedescription": "Situated in a pollution-free zone, the campsite promotes well-being and a healthy lifestyle, offering a serene environment free from noise and pollution, perfect for relaxation and rejuvenation."
  },
  {
    "WhyChooseheading": "Convenient Location Near Pune",
    "WhyChoosedescription": "Located approximately 55 km from Pune, Mauli Krushi Paryatan Kendra is easily accessible, making it an ideal destination for a quick getaway to experience nature and rural life."
  }
]

































    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Why is Morachi Chincholi a popular school picnic spot near Pune?',
    answer: 'Morachi Chincholi offers a unique blend of nature, adventure, and educational activities like peacock watching, farm visits, and traditional games, making it ideal for school outings.',
  },
  {
    id: 'FAQ2',
    question: 'What activities are available for students at Morachi Chincholi?',
    answer: 'Students can enjoy bullock cart rides, tractor rides, rain dance, swimming pool, nature walks, bird watching, and participate in fun rural games.',
  },
  {
    id: 'FAQ3',
    question: 'Are meals provided during school picnic packages?',
    answer: 'Yes, most picnic packages include nutritious Maharashtrian vegetarian meals like breakfast, lunch, and evening snacks prepared with fresh farm ingredients.',
  },
  {
    id: 'FAQ4',
    question: 'Is Morachi Chincholi safe for school children?',
    answer: 'Absolutely. The area is well-supervised by trained staff with safety measures in place, including first aid and child-friendly zones.',
  },
  {
    id: 'FAQ5',
    question: 'How far is Morachi Chincholi from Pune and Pimpri-Chinchwad?',
    answer: 'It is approximately 60-65 km from Pune and Pimpri-Chinchwad, making it easily accessible within 1.5 to 2 hours by car or bus.',
  },
  {
    id: 'FAQ6',
    question: 'Can large school groups be accommodated?',
    answer: 'Yes, Morachi Chincholi resorts and agro-tourism centers can comfortably host large groups with facilities and activities tailored to different age groups.',
  },
  {
    id: 'FAQ7',
    question: 'What is the typical duration of a school picnic at Morachi Chincholi?',
    answer: 'Most school picnics are planned for a full day, around 9:30 AM to 6 PM, including activities, meals, and rest periods.',
  },
  {
    id: 'FAQ8',
    question: 'Are there facilities for rest and shade during the picnic?',
    answer: 'Yes, there are designated rest areas, shaded seating, and clean washrooms to ensure comfort for students and teachers.',
  },
  {
    id: 'FAQ9',
    question: 'Is prior booking required for school picnics at Morachi Chincholi?',
    answer: 'Yes, it is recommended to book at least 2-3 weeks in advance, especially during peak seasons and weekends.',
  },
  {
    id: 'FAQ10',
    question: 'How can schools arrange transport to Morachi Chincholi?',
    answer: 'Schools can coordinate their own transport or seek assistance from picnic organizers who often provide bus and taxi booking services.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Meena Kulkarni, School Teacher, Pune',
    feedback: "Our students loved the entire experience at Morachi Chincholi. The activities were engaging, and the natural surroundings made it an unforgettable day.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Rajesh More, Principal, Pimpri-Chinchwad',
    feedback: "The picnic was very well organized with great safety measures and delicious food. Kids especially enjoyed the bullock cart and tractor rides!",
    rating: 5,
  },
];





































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const schoolPicnicSpotSchema = {
  "@context": "https://schema.org",
  "@type": "TouristAttraction",
  "name": "Morachi Chincholi School Picnic Spot",
  "description": "A top-rated school picnic spot in Morachi Chincholi offering farm-based educational trips, nature activities, animal interaction, guided farm tours, and age-appropriate games for students.",
  "image": "https://morachichincholi.in/assets/images/school-picnic.jpg",
  "url": "https://morachichincholi.in/school-picnic-spot",
  "touristType": {
    "@type": "Audience",
    "audienceType": "School Groups"
  },
  "location": {
    "@type": "Place",
    "name": "Anand Krushi Paryatan Kendra",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Morachi Chincholi",
      "addressRegion": "Pune",
      "addressCountry": "IN"
    }
  }
};



    return (
        <div>
<Helmet>
  <title>Morachi Chincholi School Picnic Spot | Safe & Educational Farm Outing for Students</title>
  <meta 
    name="description" 
    content="Plan your next school picnic at Morachi Chincholi. Enjoy farm-based learning, nature games, animal zones, clean lunch areas, and guided educational activities in a safe environment for students." 
  />
  <meta 
    name="keywords" 
    content="Best school-friendly spot in Morachi Chincholi, Farm-based education trip, Safe playgrounds for students, Fun animal interaction zones, Interactive farming demos, Cultural exposure for kids, Group lunch zones, Clean toilets and hygiene maintained, Games and nature activities for children, Learning via nature sessions, On-site guides and support staff, Special school packages available, Booking and travel help, Relaxing and fun environment for students, Age-appropriate games and shows" 
  />
  <script type="application/ld+json">
    {JSON.stringify(schoolPicnicSpotSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/44.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholischoolpicninc;